export default {
    event: 'Évènement',
    product: 'Produit',
    service: 'Service',
    timebank: 'Banque de temps'
};
